export default "__VITE_ASSET__D4e04jMs__"